import { helper } from "@ember/component/helper"
import { get } from "@ember/object"
import { includes, isNil } from "lodash-es"

const AVAILABLE_FEATURES = [
  "GOOGLE_CLASSROOM",
  "GC_TOPICS",
  "NON_MF_WEEKDAYS",
  "ADMIN_DASHBOARD",
  "SCRIBE_TIPTAP",
  "ADMIN_DASHBOARD_STANDARDS",
  "AI",
  "UNIFIED_PLANBOOKS",
  "ADD_LESSON_MENU",
  "FOLLOW_CLASSES",
]

export function hasFeature(args) {
  let [user, feature] = args
  if (isNil(user)) return false
  if (includes(AVAILABLE_FEATURES, feature) === false) {
    throw new Error(
      `Feature Flag Not Implemented: ${feature}. Add to has-feature.ts and cc.com/admin-backend/feature-flags.`,
    )
  }
  return get(user?.attributes?.featureFlags, feature)
}

export default helper(hasFeature)
